module.exports = ".mat-radio-group {\r\n  display: flex;\r\n  justify-content: space-around;\r\n  color: #eb008f;\r\n}\r\n"